import MarketplaceTravelerSummary from "./MarketplaceTravelerSummary.jsx";

export default function LocalErrandCard({
  offer,
  traveler,
  reputation,
  isBuyer,
  isOwner,
  onRequest,
  onDeactivate,
  onOpenReviews,
}) {
  return (
    <article className="errand-card">
      <div className="errand-card-header">
        <div>
          <span className="errand-card-kicker">Local errand</span>
          <h3>{offer.store_name}</h3>
        </div>
        <span className="pill errand-pill">{offer.remaining_slots} of {offer.slots} slots left</span>
      </div>
      <p className="errand-card-meta">Local area: {offer.public_area}</p>
      <p className="errand-card-meta">Planned: {offer.planned_date}</p>
      {offer.description && (
        <p className="listing-description">{offer.description}</p>
      )}
      <MarketplaceTravelerSummary
        traveler={traveler}
        reputation={reputation}
        reviewLabel="View runner reviews"
        onOpenReviews={onOpenReviews}
      />
      <footer>
        <b>
          Runner fee PHP{" "}
          {Number(offer.runner_fee).toLocaleString("en-PH", {
            minimumFractionDigits: 2,
          })}
        </b>
        {isBuyer && (
          <button
            disabled={offer.remaining_slots <= 0}
            onClick={onRequest}
          >
            {offer.remaining_slots > 0 ? "Request an item" : "Fully booked"}
          </button>
        )}
        {isOwner && (
          <button className="secondary" onClick={onDeactivate}>
            Deactivate
          </button>
        )}
      </footer>
    </article>
  );
}
